export const OfficeProposalLabelsState = {
	url: '/settings-proposal-labels',
	title: 'Office Proposal Labels',
	template: '<proposal-labels></proposal-labels>',
	lazyLoad: $transition$ => {
		const $ocLazyLoad = $transition$.injector().get('$ocLazyLoad');
		const $log = $transition$.injector().get('$log');
		return import(
			/* webpackChunkName: "officeSettingsProposalLabelsPageMod" */
			'@Containers/office-proposal-labels/office-proposal-labels.cmp.js'
		)
			.then(res => $ocLazyLoad.load({name: res.default}))
			.catch(err => $log.error(err));
	},
};
